import { Controller } from '@hotwired/stimulus'
import { StreamActions } from '@hotwired/turbo'
import * as Turbo from '@hotwired/turbo'

export default class extends Controller {
  static targets = ["balance"]

  async connect() {
    console.log("🔌 Wallet controller connected")
    
    // Create consumer for the stream
    this.stream = await Turbo.connectStreamSource(
      new WebSocket(`${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}/cable`)
    )

    // Subscribe to the specific channel
    this.stream.send(JSON.stringify({
      command: 'subscribe',
      identifier: JSON.stringify({
        channel: 'Turbo::StreamsChannel',
        signed_stream_name: 'wallets'
      })
    }))

    this.stream.addEventListener('message', (event) => {
      const data = JSON.parse(event.data)
      console.log("📬 Stream message received:", data)
    })

    this.stream.addEventListener('open', () => {
      console.log("✅ Stream connection opened")
    })
  }

  disconnect() {
    console.log("🔌 Wallet controller disconnected")
    if (this.stream) {
      Turbo.disconnectStreamSource(this.stream)
    }
  }
}
